import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { StyledSwitch } from "../../../components/Base";
import Button from "../../../components/Button";
import TableComponent from "../../../components/TableComponent";
import Confirm from "../../../components/Confirm";
import {
  getUsersTraining,
  getUsersTrainingByTrainingId,
  inscribeOrUniscribeUserToCourse,
  getTraining,
} from "../../../api/training.deprecated";
import { concatRolesUsers } from "../../../services/user";

const InscribeTraining = ({ match, history }) => {
  const { t } = useTranslation();
  const [usersToInscribe, setUsersToInscribe] = useState(null);
  const [trainingCourse, setTrainingCourse] = useState(null);
  const [refresh, setRefresh] = useState(1);
  const [isModalShow, setIsModalShow] = useState(false);

  useEffect(() => {
    (async () => {
      const trainingId = match.params.trainingId;
      const usersToInscribe = await getUsersTrainingByTrainingId(trainingId);
      setUsersToInscribe(
        usersToInscribe.filter((item) => !["trainer", "instructor", "checker", "assessor"].includes(item.role_name)),
      );
    })();
  }, [refresh]);

  async function confirmModal() {
    setIsModalShow(false);
  }

  return (
    <>
      <Typography variant="h4">{t("course_training.inscribed_users")}</Typography>
      {usersToInscribe ? (
        <TableComponent
          header={[
            { title: t("training_pages.user_id"), style: { width: "5%" } },
            { title: t("user") },
            { title: t("operations") },
            { title: t("role.name") },
            { title: t("training_pages.crew") },
            { title: t("course_training.inscribe") },
          ]}
          renderChildren={(userToInscribe, index) => (
            <TableRow key={index}>
              <TableCell>{userToInscribe.user_id}</TableCell>
              <TableCell>{userToInscribe.fullname}</TableCell>
              <TableCell>{userToInscribe.operation_name}</TableCell>
              <TableCell>{userToInscribe.role_name}</TableCell>
              <TableCell>{userToInscribe.company_name}</TableCell>
              <TableCell>
                <StyledSwitch
                  title={t("course_training.inscribe_user_to_course")}
                  checked={userToInscribe.inscribe_id != null}
                  onChange={async () => {
                    /*                     
                    if (trainingCourse.userInscribe < trainingCourse.trainingSlot) {
                      await inscribeOrUniscribeUserToCourse(userToInscribe.inscribe_id, userToInscribe.id, userToInscribe.user_id, userToInscribe.crew_id, userToInscribe.course_id, 'user', userToInscribe.valid_period);  
                    } else if  (trainingCourse.userInscribe == trainingCourse.trainingSlot && !event.target.checked) { 
                      await inscribeOrUniscribeUserToCourse(userToInscribe.inscribe_id, userToInscribe.id, userToInscribe.user_id, userToInscribe.crew_id, userToInscribe.course_id, 'user', userToInscribe.valid_period); 
                    } else {
                      setIsModalShow(true)
                    }       
 */
                    await inscribeOrUniscribeUserToCourse(
                      userToInscribe.inscribe_id,
                      userToInscribe.id,
                      userToInscribe.user_id,
                      userToInscribe.crew_id,
                      userToInscribe.course_id,
                      "user",
                      userToInscribe.valid_period,
                    );
                    setRefresh(refresh + 1);
                  }}
                />
              </TableCell>
            </TableRow>
          )}
          search={["user_id", "fullname", "company_name"]}
          pagination
          items={usersToInscribe}
        />
      ) : null}
      <Button title={t("navigate_back")} type="button" onClick={() => history.push("/trainings")}>
        {t("training_pages.return_to_all_trainings")}
      </Button>

      {isModalShow ? (
        <Confirm title={t("course_training.max_slots")} notification={true} onConfirm={confirmModal}>
          <p>{t("course_training.max_slots_reached")}</p>
        </Confirm>
      ) : null}
    </>
  );
};

export default InscribeTraining;
